module.exports = {"new":"New","unavailable":"Unavailable","noHistorySubtitle":"records","historySubtitle":"active/incl. history"}